import React from "react";

import { ListSection } from "components/slate/plugins/menus/atMenu/components/types";

import styles from "./index.module.scss";
import cn from "classnames";

type SectionMenuListSectionProps<T> = {
  section: ListSection<T>;
};

const SectionMenuListHeader = <T,>({
  section,
}: SectionMenuListSectionProps<T>) => {
  return <div className={cn(styles.header, section.className)}>{section.title}</div>;
};

export default SectionMenuListHeader;
